import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const AIDataSolutions = () => {

  const projects = [
    { title: "Data Dashboard", desc: "Analytics dashboard for business insights.", link: "#" },
  ];

  const testimonials = [
    { name: "Ayesha Malik", role: "Data Analyst", feedback: "Powerful insights and dashboards." },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[500px] h-[500px] bg-blue-600/30 blur-[120px] rounded-full top-20 left-1/2 -translate-x-1/2"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            AI & <span className="text-blue-400">Data Solutions</span>
          </h1>
          <p className="mt-6 text-gray-300">Transform data into actionable insights.</p>

          <div className="mt-10 flex gap-4 justify-center">
            <Link to="/contact" className="px-8 py-4 bg-blue-500 rounded-full">Start Now</Link>
            <a href="https://calendly.com/thelogicwaves/30min" className="px-8 py-4 border rounded-full">Book Call</a>
          </div>
        </div>
      </section>

      {/* WHAT WE DO */}
      <section className="py-24 grid md:grid-cols-3 gap-8 max-w-6xl mx-auto px-6">
        {["Data Analytics","AI Models","Dashboards","Predictive Analysis","Big Data","ML Solutions"].map((item,i)=>(
          <div key={i} className="bg-white/5 p-6 rounded-xl">
            <h3 className="text-blue-400">{item}</h3>
          </div>
        ))}
      </section>

      <ProjectsSection projects={projects} />
      <Testimonials testimonials={testimonials} />

      {/* CTA */}
      <section className="py-28 text-center bg-gradient-to-r from-blue-500 to-cyan-500">
        <h2 className="text-4xl font-bold mb-6">Unlock Your Data Power 🚀</h2>
        <Link to="/contact" className="bg-black px-6 py-3 rounded">Contact Us</Link>
      </section>

    </div>
  );
};

export default AIDataSolutions;